import React, { useEffect, useRef } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from '@mui/styles';
import { debounce } from '@/helpers/utils';
import styles from './Resizer.module.scss';

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: 14,
  },
}));

type ResizerProps = {
  range?: { min: number; max: number };
  tooltipText?: string;
  position?: 'Left' | 'Right';
  onResize?: (value: number, save?: boolean) => void;
  saveResizeValue?: (value: number) => void;
};

const Resizer: React.FC<ResizerProps> = (props) => {
  const { range = { min: 0, max: 0 }, tooltipText = '', position = 'Right', onResize = () => { }, saveResizeValue = () => { } } = props;
  const ref = useRef(null);
  const width = useRef(range.min);
  const ttStyles = useStyles();
  const classes = `${styles.Resizer} ${styles[position] || ''}`;

  useEffect(() => {
    const resize = debounce((ev) => {
      ev.preventDefault();
      const offset = position === 'Left' ? window.innerWidth : 0;
      const rangeMin = Math.abs(offset - range.min);
      const rangeMax = Math.abs(offset - range.max);
      const valueInRange = Math.min(Math.max(rangeMin, ev.clientX), rangeMax);
      const value = Math.abs(offset - valueInRange);

      if (value !== width.current) {
        width.current = value;
        onResize(value, false);
      }
    }, 60);

    const mouseup = () => {
      saveResizeValue(width.current);
      window.removeEventListener('mousemove', resize);
      window.removeEventListener('mouseup', mouseup);
    };

    const currentNode = ref?.current;

    if (currentNode) {
      currentNode.addEventListener('mousedown', (e) => {
        e.preventDefault();
        window.addEventListener('mousemove', resize);
        window.addEventListener('mouseup', mouseup);
      });
    }
  }, [ref]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Tooltip ref={ref} title={tooltipText} placement={position.toLowerCase()} leaveDelay={500} classes={{ tooltip: ttStyles.tooltip }}>
      <div className={classes} />
    </Tooltip>
  );
};

export default Resizer;
